import React from "react";
import Title from "./Detail/Title";
import { Formik } from "formik";
import { ReservationLoginShema } from "../validations/ReservationsLoginShema";
import { useTranslation } from "../context/TranslationContext";
import { GavelLogin } from "./api";
import { toast } from "react-toastify";
import { Icon } from "../icons/icons";
import { GavelLoginSheme } from "../validations/GavelLoginSheme";

const GavelLoginForm = ({ setGavelLoginSuccess, emlak }) => {
  const {
    loginRightDescription,
    loginRightDescriptionContactLink,
    loginLeftSubtitle,
    loginLeftTitle,
    loginLeftCopyRight,
    welcome,
    loginSuccess,
    loginFormEmail,
    loginReservationNumber,
    login,
    loginRightDescriptionBottom,
  } = useTranslation();
  return (
    <div className="lg:mt-1 m-auto max-w-screen-sm p-10">
      {/* <div className="bg-blue-50 p-4 rounded-lg text-center">
        <div className="w-28 mx-auto">
          <Icon name={"ktb"} className={""} />
        </div>
        <p className="mt-2">
          Uyarı ! 7464 Sayılı Konutların Turizm Amaçlı Kiralanması Kanunu
          Kapsamında, ilgili ilana ait kiralama belgesi olmadığı için yayından
          kaldırılmıştır. Lütfen rezervasyon kontrolunuz için rezervasyon
          bilgilerinizi giriniz!
        </p>
      </div> */}
      <div className="mt-10">
        <Title>Rezervasyon Girişi</Title>
        <Formik
          initialValues={{
            reservationNumber: "",
          }}
          validationSchema={GavelLoginSheme}
          onSubmit={(values, actions) => {
            GavelLogin(values.reservationNumber, emlak)
              .then((response) => {
                if (response.data.success) {
                  setGavelLoginSuccess(1);
                  toast.success(loginSuccess);
                } else {
                  toast.error(response.data.error);
                }
              })
              .catch((error) => {
                toast.error(error.message);
              })
              .finally(() => {
                actions.setSubmitting(false);
              });
          }}
        >
          {(props) => (
            <form
              className="mb-[54px] w-full mt-3"
              onSubmit={props.handleSubmit}
            >
              <div className="relative z-0 mb-[13px] w-full group">
                <input
                  id="reservationNumber"
                  className="block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border border-[#dee9ed] appearance-none  focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
                  placeholder=" "
                  onChange={props.handleChange}
                  value={props.values.reservationNumber}
                ></input>
                <label
                  htmlFor="reservationNumber"
                  className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form  duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3  left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
                >
                  {loginReservationNumber}
                </label>
              </div>
              <p className="text-sm mb-3 text-red-600">
                (Rezervasyon İşlemlerinde kullandığınız mail adresinizden
                ulaşabilirsiniz.)
              </p>
              <button
                disabled={props.isSubmitting || !props.isValid || !props.dirty}
                type="submit"
                className="text-white md:px-[2.75rem] px-8 md:py-[1.188rem] py-3 duration-200 bg-product-type-color hover:opacity-90 focus:ring-4  font-medium rounded-lg text-sm  text-center disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {login}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
//d
export default GavelLoginForm;
